// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "9e4d283";
